import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";

import { MagnifyingGlassIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid'
import {
  Bars3Icon,
  BellIcon,
  CogIcon,
  CreditCardIcon,
  KeyIcon,
  SquaresPlusIcon,
  UserCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'


import { BuildingOfficeIcon, UserIcon, UsersIcon, PencilIcon, TrashIcon } from '@heroicons/react/20/solid'

import { Company } from "@/views/Settings/Company";
import { Invoice } from "@/views/Settings/Invoice";
import { Interest } from "@/views/base/user/Interest";
import {storeBaseSetting2, removeBaseSetting} from "@/reducers/Settings";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";

export function WorkTypeSettingsView({...props}) {
    const [settings, setSettings] = useState((props.SettingsReducer && props.SettingsReducer.settings_worktypes) ? props.SettingsReducer.settings_worktypes : []);
    const [action, setAction] = useState("");

    const editItem = (event, item) => {
        setAction( item.key );
    }
    const cancel = (event) => {
        let newArray = [...props.SettingsReducer.settings_worktypes];
        setSettings( newArray );
        setAction( "" );
    }
    const addItem = (event) => {
        let key = "NEW";
        let obj = {key:key, name: "Invullen", price: 0.00};
        let newArray = [...settings, obj];
        setSettings( newArray );
        setAction( key );
        return false;
    }
    
    const saveItem = (event) => {
        event.preventDefault();
        event.stopPropagation();
    
        const data = new FormData(event.target);
        const values = Object.fromEntries(data.entries());
        store.dispatch( storeBaseSetting2( {data: values, type: "worktype"} ) ).then((dataRet) => {
            if(props?.window?.onSaveHandler) {
                props.window.onSaveHandler(dataRet.payload.data.workTypes);                
            }
                });

//        setAction( "" );
        return false;

    }    

    const removeItem = (event, item) => {
        event.preventDefault();
        event.stopPropagation();
    
        store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));

//        setAction( "" );
        return false;

    }    

const confirmedRemoveHandler = (propsData) => {
    store.dispatch( removeBaseSetting({data: propsData.item, type: "worktype"}) ).then((data) => {
        console.debug( data )
        console.debug( props?.window?.onSaveHandler )
        if(props?.window?.onSaveHandler) {
            props.window.onSaveHandler(data.payload.data.workTypes);                
        }
                    });
    store.dispatch(hideModal(null));
}
    
//    const {settings_worktypes} = SettingsReducer;
         return (
<form onSubmit={saveItem}>
                    {action != ""  &&
                        <input name="key" type="hidden" defaultValue={action} />
                    }


                  <div className="shadow sm:overflow-hidden sm:rounded-md">
                    <div className="bg-white px-4 py-6 sm:p-6">
                        {settings && settings.length >= 0 && 
          <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 w-4">
                    <span className="sr-only">Edit</span>
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Naam
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-18">
                    Prijs
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {settings.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 flex">
                        {action == "" &&
                        <>
                        <TrashIcon className="w-3 h-5 cursor-pointer" onClick={() => removeItem(event, item)}/>
                        <PencilIcon className="w-3 h-5 cursor-pointer" onClick={() => editItem(event, item)}/>
                        </>
                        }
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 ">
                    {action != "" && action == item.key &&
<input
          name="name"
          type="text"
          defaultValue={item.name}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-1"
        />                    
                    }
                    {action == "" && 
                    item.name
                    }
                    {action != "" && action != item.key && 
                    <span className="text-gray-200">{item.name}</span>
                    }
                    
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    
                    {action != "" && action == item.key &&
                    
      <div className="relative mt-2 rounded-md shadow-sm">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-1">
          <span className="text-gray-500 sm:text-sm">&euro;</span>
        </div>
        <input
          id="price"
          name="price"
          type="text"
          placeholder="0.00"
          defaultValue={item.price}
          aria-describedby="price-currency"
          className="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
        </div>
                    }
                    {action == "" && 
                    item.price
                    }
                    {action != "" && action != item.key && 
                    <span className="text-gray-200">{item.price}</span>
                    }
                    
                    
                    </td>
                        
                        
                    </tr>                        
                ))}
              </tbody>
            </table>
            }
                    </div>
                    
                    <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
                    {action == "" && 
                      <button
                        onClick={() => addItem(event)}
                        type="button"
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Toevoegen
                      </button>
                      }
                      
                    {action != "" &&
                        <>
                      <button
                        type="button"
                        onClick={() => cancel(event)}
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Annuleren
                      </button>
 
                      <button
                        type="submit"
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Bewaren
                      </button>
                      </>
                      }
                      
                      
                    </div>
                    
                  </div>
                  
                </form>
    );    
}